import { useRegion } from "../../Regions/hooks/useRegion.js";
import { sameWallClock, toLocalUnavailableTimes, toStoredUnavailableTimes } from "../shared/availability/zone-conversion.js";
// src/modules/Scheduling/hooks/useAvailabilityZones.ts
var deviceZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
function usable(zone) {
	if (!zone) return void 0;
	try {
		new Intl.DateTimeFormat("en-US", { timeZone: zone });
		return zone;
	} catch {
		return;
	}
}
/**
* Availability is stored as wall clock in the user's primary region zone;
* people read and enter it in `viewZone` (the device's when left out). With
* no usable primary region zone the blocks pass through unchanged, as the
* server then reads them in the region being viewed.
*/
function useAvailabilityZones(primaryRegionId, viewZone) {
	const region = useRegion(primaryRegionId ? { regionId: primaryRegionId } : void 0, { cacheStrategy: "cache-first" });
	const regionZone = region.data?.region?.timezone;
	const storedZone = usable(regionZone);
	const view = viewZone ?? deviceZone();
	return {
		/** The zones read differently this week, so conversions are worth showing. */
		differs: !!storedZone && !sameWallClock(storedZone, view),
		/**
		* Still looking up the primary region's zone. Done once the lookup
		* answers, even without a zone (a region can be saved without one) or
		* with an error: blocks then pass through, as the server does.
		*/
		loading: !!primaryRegionId && !region.data && !region.error,
		storedZone,
		toLocal: (blocks) => storedZone ? toLocalUnavailableTimes(blocks, storedZone, view) : blocks,
		toStored: (blocks) => storedZone ? toStoredUnavailableTimes(blocks, view, storedZone) : blocks,
		viewZone: view
	};
}
export { useAvailabilityZones };

//# sourceMappingURL=useAvailabilityZones.js.map